import { api } from "@/lib/api";

export const pushSupported = () =>
  typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const needsHomeScreen = () => isIOS() && !isStandalone();

export const permission = () => (pushSupported() ? Notification.permission : "unsupported");

export const registerSW = () => {
  if (!("serviceWorker" in navigator)) return Promise.resolve(null);
  return navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => null);
};

const b64ToBytes = (s) => {
  const pad = "=".repeat((4 - (s.length % 4)) % 4);
  const raw = atob((s + pad).replace(/-/g, "+").replace(/_/g, "/"));
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) out[i] = raw.charCodeAt(i);
  return out;
};

// Returns subscription JSON or null. Asks permission only when ask=true (must come from a tap).
export async function getSubscription(ask = false) {
  if (!pushSupported() || needsHomeScreen()) return null;
  if (Notification.permission === "default" && ask) await Notification.requestPermission();
  if (Notification.permission !== "granted") return null;
  await registerSW();
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await api.get("/push/public-key");
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToBytes(data.public_key) });
  }
  const json = sub.toJSON();
  return { endpoint: json.endpoint, keys: json.keys };
}
